/**
 * usePersistedText — one owner for an inline-edited text field on the tend
 * card (Buggie Boo 3ec9a8a4…fc56, 2026-10-01: the category pill kept
 * reverting to its old text).
 *
 * The string instance of usePersistedValue, which carries the contract
 * (state owns the DOM, debounce + blur/unmount flush, last-saved compare,
 * stale-refetch guard, record reset, only-this-instance-writes). Kept as its
 * own name because the card reads better with "text" fields and "value"
 * fields told apart.
 */
import { usePersistedValue, PersistedValue, PersistedValueOptions } from './usePersistedValue';

export type PersistedTextOptions = Omit<PersistedValueOptions<string>, 'key'>;
export type PersistedText = PersistedValue<string>;

export function usePersistedText(options: PersistedTextOptions): PersistedText {
  return usePersistedValue<string>(options);
}
